import { createEnv } from '@t3-oss/env-core';
import memoizee from 'memoizee';
import { z } from 'zod';

import.meta.env.VITE_API_URL;

export const env = memoizee(() => {
  const currentEnv = createEnv({
    clientPrefix: 'VITE_',
    client: {
      VITE_API_URL: z.string(),
      VITE_HASURA_URL: z.string(),
      VITE_ENV: z.enum(['local', 'development', 'staging', 'production']),
      VITE_PAIRING_APP_URL: z.string(),
    },
    runtimeEnv: import.meta.env,
  });

  return currentEnv;
});
